import * as v from 'valibot';

const getOptionSchema = (message?: string) => ({
  id: v.string(message),
  label: v.string(message),
});

export const laneSearchFormSchema = v.object({
  carrierKey: v.optional(v.number()),
  carrierName: v.optional(v.string()),
  destinationCity: v.optional(v.string()),
  destinationCountry: v.object(getOptionSchema('Country is required')),
  destinationPortKey: v.optional(v.number()),
  destinationPortName: v.optional(v.string()),
  destinationPostal: v.optional(v.string()),
  destinationState: v.optional(v.object(getOptionSchema())),
  laneCode: v.optional(v.string()),
  originCity: v.optional(v.string()),
  originCountry: v.object(getOptionSchema('Country is required')),
  originPortKey: v.optional(v.number()),
  originPortName: v.optional(v.string()),
  originPostal: v.optional(v.string()),
  originState: v.optional(v.object(getOptionSchema())),
});

export const laneSearchParamsSchema = v.object({
  carrierCorporation: v.optional(v.boolean()),
  carrierKey: v.optional(v.number()),
  destinationCity: v.optional(v.string()),
  destinationCountry: v.optional(v.string()),
  destinationPortKey: v.optional(v.number()),
  destinationPostal: v.optional(v.string()),
  destinationState: v.optional(v.string()),
  laneCode: v.optional(v.string()),
  laneKey: v.optional(v.number()),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  originCity: v.optional(v.string()),
  originCountry: v.optional(v.string()),
  originPortKey: v.optional(v.number()),
  originPostal: v.optional(v.string()),
  originState: v.optional(v.string()),
  providerLaneId: v.optional(v.string()),
});

export const laneSchema = v.object({
  carrierCorporation: v.nullish(v.boolean()),
  carrierKey: v.nullish(v.number()),
  createdBy: v.nullish(v.number()),
  createdOn: v.nullish(v.string()),
  laneCode: v.nullish(v.string()),
  laneKey: v.number(),
  modifiedBy: v.nullish(v.number()),
  modifiedOn: v.nullish(v.string()),
  providerLaneID: v.nullish(v.string()),
});

export const lanePagedResultSchema = v.object({
  items: v.nullish(v.array(laneSchema)),
  totalCount: v.number(),
});

export type LaneSearchFormValues = v.InferOutput<typeof laneSearchFormSchema>;
export type LanesParams = v.InferOutput<typeof laneSearchParamsSchema>;
export type LaneItem = v.InferOutput<typeof laneSchema>;
export type LanePagedResult = v.InferOutput<typeof lanePagedResultSchema>;
export type LaneRow = LaneItem & { id: string };
export type Lanes = LaneRow[];
export type LanesApi = { data: Lanes; total: number };
